import {
  Component,
  OnInit,
  Input,
  SimpleChanges,
  OnChanges
} from '@angular/core';

@Component({
  selector: 'app-mobile-wizard-progress-indicator',
  templateUrl: './mobile-wizard-progress-indicator.component.html',
  styleUrls: ['./mobile-wizard-progress-indicator.component.css']
})
export class MobileWizardProgressIndicatorComponent implements OnInit,
    OnChanges {
  @Input() currentStep = 0;
  @Input() numberOfSteps = 0;

  steps: number[];
  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (this.numberOfSteps) {
      this.steps = [];
      for (let i = 0; i < this.numberOfSteps; i++) {
        this.steps.push(i);
      }
    }
  }
}
